module.exports = __webpack_public_path__ + "static/media/Mobilite_PictoCdlT.7cc39267.png";